export const  GET_MAIN_PDF_REQUEST='mainPdfReducer/GET_MAIN_PDF_REQUEST';
export const  GET_MAIN_PDF_SUCCESS='mainPdfReducer/GET_MAIN_PDF_SUCCESS';
export const  GET_MAIN_PDF_FAILED='mainPdfReducer/GET_MAIN_PDF_FAILED';